import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=2562e61e&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2562e61e')) {
      api.createRecord('2562e61e', component.options)
    } else {
      api.reload('2562e61e', component.options)
    }
    module.hot.accept("./Mobile.vue?vue&type=template&id=2562e61e&", function () {
      api.rerender('2562e61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/KeyPlan/Summaries/Mobile.vue"
export default component.exports